import ApiService from "@/services/api.service";

const path = '/api/notifications'

const Service = {
    findUnread: async function () {
        return ApiService.get(path)
    },
    markRead: async function (id) {
        return ApiService.post(path + '/' + encodeURIComponent(id) + '/read')
    }
}

export default Service
